import React from 'react';

import { CheckCircleIcon } from '@vlabs/icons';
import { Margin } from '@vlabs/uikit';
import { Trans } from 'react-i18next';
import { Link } from 'react-router-dom';

import st from './CreateHandlerForm.module.sass';
import {
  keyPrefix, namespace, useCreateHandlerTranslation,
} from './i18n';

interface CreatedHandlerFormProps {
  handlerId?: string;
  handlerName?: string;
}

function CreatedHandlerForm({
  handlerId = undefined,
  handlerName = undefined,
}: CreatedHandlerFormProps): React.JSX.Element {
  const { t } = useCreateHandlerTranslation();

  return (
    <React.Fragment>
      <Margin display="block">
        <div className={st.HeaderContainer}>
          <CheckCircleIcon className={st.Icon} />
          <h5>
            {t('success.title', { description: handlerName })}
          </h5>
        </div>
      </Margin>

      <Margin display="block">
        <div className="Body-2">
          <p>
            <Trans
              i18nKey={`${keyPrefix}.success.text`}
              ns={namespace}
              values={{ handlerId }}
            />
          </p>
          <p>
            <Trans
              components={{
                a: <Link
                  data-testid="linkToHandler"
                  to={`/handlers/${handlerId}/edit`}
                />,
              }}
              i18nKey={`${keyPrefix}.success.description`}
              ns={namespace}
            />
          </p>
        </div>
      </Margin>
    </React.Fragment>
  );
}

export { CreatedHandlerForm };
